import PropTypes from 'prop-types'

import Icon from '../Icons'

const Pagination = ({ setPageNumber, pageNumber, countOfAllPaginationBlocks, setSiteLoading }) => {
  const showPrevPage = () => {
    if (pageNumber === 1) return null
    setPageNumber(pageNumber - 1)
  }

  const showNextPage = () => {
    if (countOfAllPaginationBlocks === pageNumber) return null
    setPageNumber(pageNumber + 1)
  }

  const changePage = (newPageNumber) => {
    setSiteLoading(true)
    setPageNumber(newPageNumber)
  }

  const getProperStart = (actuallPage, countOfAllPages) => {
    if (actuallPage === countOfAllPages) return actuallPage - 5
    if (actuallPage === countOfAllPages - 1) return actuallPage - 4
    return actuallPage - 3
  }

  const getProperLimit = (actuallPage, countOfAllPages) => {
    if (actuallPage === countOfAllPages - 1) return actuallPage + 1
    if (actuallPage === 1) return actuallPage + 4
    if (actuallPage === 2) return actuallPage + 3
    return actuallPage + 2
  }

  return (
    <div className="pagination-wrapper">
      <div className="pagination-container">
        <div
          className="paginations-block"
          style={{ transform: 'rotate(180deg)' }}
          onClick={() => showPrevPage()}
        >
          <Icon icon={'arrow'} viewBox={'-5 -5 30 30'} fill={'grey'} />
        </div>
        {/* get Prev buttons */}
        {[...new Array(pageNumber - 1)]
          .map((x, index) => {
            return (
              <div key={index} className="paginations-block" onClick={() => changePage(index + 1)}>
                {index + 1}
              </div>
            )
          })
          .filter((_x, index) => index >= getProperStart(pageNumber, countOfAllPaginationBlocks))}
        {/* actuall button */}
        {<div className="paginations-block selected">{pageNumber}</div>}
        {/* get Next buttons */}
        {[...new Array(pageNumber + 4)]
          .map((x, index) => {
            return (
              <div key={index} className="paginations-block" onClick={() => changePage(index + 1)}>
                {index + 1}
              </div>
            )
          })
          .filter((_x, index) => index < countOfAllPaginationBlocks)
          .slice(pageNumber, getProperLimit(pageNumber, countOfAllPaginationBlocks))}
        <div className="paginations-block" onClick={() => showNextPage()}>
          <Icon icon={'arrow'} viewBox="-5 -5 30 30" fill={'grey'} />
        </div>
      </div>
    </div>
  )
}

Pagination.propTypes = {
  setPageNumber: PropTypes.func,
  pageNumber: PropTypes.number,
  countOfAllPaginationBlocks: PropTypes.number,
  setSiteLoading: PropTypes.func,
}

export default Pagination
